import React, { useState } from "react"
import { useSiteQuery, useUrl, useLocale, useLocalPath } from "../../../hooks"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import { GlobIcon } from "../../../svgs/play"
import * as styles from "./footer.module.scss"

import { RichText } from "../RichText/RichText";


const Footer = () => {
    const {
        footerContactUsLink,
        footerSiteLanguages,
        footerMenuItems,
        footerSocialIcons,
        footerUnileverLogo,
        footerCopyrightDescription,
        footerCopyrightLongDescription,
    } = useSiteQuery()
    const baseUrl = useUrl();    

    const externalLink = (link) => {
        return (link.split('/').includes('https:') || link.split('/').includes('http:'))
    }

    const events = ['scroll', 'mousemove', 'touchstart'];
    const [svgInteraction, setSvgInteraction] = useState(false)
    const initButton = () => {
        setSvgInteraction(true)

        events.forEach(event => {
            window.removeEventListener(event, initButton)
        })
    }
    if (typeof window !== 'undefined') {
        events.forEach(event => {
            window.addEventListener(event, initButton)
        })
    }


    const locale = useLocale()

    return (
        <footer className={styles.footer_module}>
            <div className={`${styles.footer_module__top} spacer__01`}>
                <div className={styles.col_1}>
                    <GlobIcon className={null} />
                    {
                        footerContactUsLink[0].slug.includes('http')
                            ? <a href={footerContactUsLink[0].slug}>
                                {footerContactUsLink[0].title}
                            </a>
                            : <Link to={useLocalPath(footerContactUsLink[0].slug)}>
                                {footerContactUsLink[0].title}
                            </Link>
                    }
                    {
                        (locale === 'en-EG' || locale === 'ar-EG' || locale === 'en-AE' || locale === 'ar-AE') &&
                        <p>
                            <Link
                                to={`${footerSiteLanguages[0].slug}`}
                                className="btn__secondary"
                            >
                                العربية
                            </Link>
                            <Link
                                to={`${footerSiteLanguages[1].slug}`}
                                className="btn__secondary">
                                English
                            </Link>
                        </p>
                    }
                </div>
                <div className={styles.col_2}>
                    <ul className={styles.footer__nav}>
                        {footerMenuItems.map((items: any, index: number) => {
                            const { title, slug } = items
                            if (externalLink(slug)) {
                                return (
                                    <li key={index} >
                                        <a href={slug} target="_blank">
                                            {title}
                                        </a>
                                    </li>
                                )
                            } else {
                                return (
                                    <li key={index} >
                                        <Link to={useLocalPath(`/${slug}`)} target="_blank">
                                            {title}
                                        </Link>
                                    </li>
                                )
                            }
                        })}
                    </ul>
                </div>
                {
                    svgInteraction &&
                    <div className={styles.col_3}>
                        <ul className={`${styles.social__icons} ${styles.d_flex}}`}>
                            {footerSocialIcons.map((items: any, index: number) => {
                                const { title, slug, image } = items
                                if (externalLink(slug)) {
                                    return (
                                        <li key={index}>
                                            <a href={`${slug}`}>
                                                <Img
                                                    fluid={image[0].fluid}
                                                    className={title}
                                                    alt={title}
                                                ></Img>
                                            </a>
                                        </li>
                                    )
                                } else {
                                    return (
                                        <li key={index}>
                                            <Link to={useLocalPath(`/${slug}`)}>
                                                <Img
                                                    fluid={image[0].fluid}
                                                    className={title}
                                                    alt={title}
                                                ></Img>
                                            </Link>
                                        </li>
                                    )
                                }
                            })}
                        </ul>
                    </div>
                }
            </div>
            <div className={styles.footer_module__bottom}>
                <a href={footerUnileverLogo.slug}>
                    <Img
                        fluid={footerUnileverLogo.image[0].fluid}
                        className={footerUnileverLogo.title}
                        alt={footerUnileverLogo.title}
                    ></Img>
                </a>

                { (locale !== "en-PK") ? <span>{footerCopyrightDescription.footerCopyrightDescription}</span>
                :
                <RichText content={footerCopyrightLongDescription} />}
            </div>
        </footer>
    )
}

export default Footer
